import { GetCommonClassifierElementListResponseItem } from 'src/api/requests'

export type AidsCategoryLetter = 'a' | 'b' | 'c'

const isAidsCategoryLetter = (value?: string): value is AidsCategoryLetter =>
  value === 'a' || value === 'b' || value === 'c'

/** The CDC letter (a, b or c) of an AIDS clinical category element (A1…C3): its key, else its Romanian name. */
export const aidsCategoryLetterOf = (
  element?: GetCommonClassifierElementListResponseItem
): AidsCategoryLetter | undefined => {
  const source = element?.originalValue || element?.translation?.ro
  const letter = source?.trim().charAt(0).toLowerCase()

  return isAidsCategoryLetter(letter) ? letter : undefined
}
